import React from 'react';
import styled from '@emotion/styled';
import { getFirstUppercase } from '../helper'
import PropTypes from 'prop-types';
const ContainerResume = styled.div`
    padding:1rem;
    text-align:center;
    background-color:#00838F;
    color: #FFF;
    margin-top:1rem;
`;

const Resume = ({ data }) => {

    // extraer de datos 
    const { brand, year, plan } = data;

    if (brand === ''
        || year === ''
        || plan === ''
    ) {
        return null;
    }

    return (
        <ContainerResume>
            <h2>Resumen de cotización</h2>
            <ul>
                <li>Marca: {getFirstUppercase(brand)}</li>
                <li>Plan: {getFirstUppercase(plan)}</li>
                <li>Año del auto: {year}</li>
            </ul>
        </ContainerResume>
    );
}
Resume.propTypes = {
    data:PropTypes.object.isRequired
}
export default Resume;